export const normalizeTypeOfViewsValue = (rawValue: any): Array<{ type: string }> => {
  if (!Array.isArray(rawValue)) {
    return [];
  }

  return rawValue.reduce<Array<{ type: string }>>((result, item) => {
    if (typeof item === 'string') {
      result.push({ type: item });
      return result;
    }

    if (item && typeof item.type === 'string') {
      result.push({ type: item.type });
    }

    return result;
  }, []);
};

export const extractTypeValues = (rawValue: any): string[] => {
  const normalized = normalizeTypeOfViewsValue(rawValue);
  return normalized.map((item) => item.type);
};

export const generateDefaultExpandPanel = (regionLocales: string[]) => {
  const expandPanel: any = {};
  regionLocales.map((item) => {
    return (expandPanel[item] = true);
  });
  return expandPanel;
};

export const normalizeTypeOfViewTypes = (typeOfView: any): string[] => {
  if (!Array.isArray(typeOfView?.types)) {
    return [];
  }

  const uniqueTypes = Array.from(new Set(typeOfView.types));
  return uniqueTypes
    .reduce<string[]>((result, typeValue) => {
      if (typeof typeValue === 'string') {
        result.push(typeValue);
      }
      return result;
    }, [])
    .sort();
};

export const hasTypeOfViewChanged = (nextTypeOfView: any, prevTypeOfView: any): boolean => {
  const nextTypes = normalizeTypeOfViewTypes(nextTypeOfView);
  const prevTypes = normalizeTypeOfViewTypes(prevTypeOfView);
  const isTypesChanged =
    nextTypes.length !== prevTypes.length || nextTypes.some((typeValue, index) => typeValue !== prevTypes[index]);

  const isLegacyTypeChanged = nextTypeOfView?.type !== prevTypeOfView?.type;
  const isIncludeSAChanged = Boolean(nextTypeOfView?.includeSA) !== Boolean(prevTypeOfView?.includeSA);
  const isUserFileChanged = nextTypeOfView?.userFile?.id !== prevTypeOfView?.userFile?.id;

  return isLegacyTypeChanged || isIncludeSAChanged || isTypesChanged || isUserFileChanged;
};
